var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { CoreStitchUserImpl } from "mongodb-stitch-core-sdk";

var StitchUserImpl = function (_super) {
  __extends(StitchUserImpl, _super);

  function StitchUserImpl(id, loggedInProviderType, loggedInProviderName, isLoggedIn, lastAuthActivity, profile, auth, customData) {
    var _this = _super.call(this, id, loggedInProviderType, loggedInProviderName, isLoggedIn, lastAuthActivity, profile, customData) || this;

    _this.auth = auth;
    return _this;
  }

  StitchUserImpl.prototype.linkWithCredential = function (credential) {
    return this.auth.linkWithCredential(this, credential);
  };

  StitchUserImpl.prototype.linkUserWithRedirect = function (credential) {
    return this.auth.linkWithRedirectInternal(this, credential);
  };

  return StitchUserImpl;
}(CoreStitchUserImpl);

export default StitchUserImpl;